import { createSelector } from 'reselect';

import { selectOptimistic } from '../selectors';

export const getOptimisticMessages = createSelector(
  selectOptimistic,
  (optimistic) => optimistic.messages
);
